'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('currentScope', function ($rootScope, $q) {

    function isInCurrentScope(rootScope, scope) {
      if (!rootScope || !scope) {
        return false;
      }
      do {
        if (rootScope === scope) {
          return true;
        }
      } while (scope = scope.$parent);
      return false;
    }

    var rootScope = null;

    return {
      get: function get() {
        return rootScope || window.angular.element(this.getActiveView()).scope();
      },
      getActiveView: function getActiveView() {
        var elements = document.querySelectorAll('[nav-view="active"]');
        return elements[elements.length - 1];
      },
      getStageView: function getStageView() {
        return document.querySelector('[nav-view="stage"]');
      },
      getActiveModal: function getActiveModal() {
        return document.querySelector('.modal.active');
      },
      ready: function ready(scope, callback) {
        var deferred = $q.defer();
        if (isInCurrentScope(rootScope, scope)) {
          deferred.resolve();
        } else {
          var onEvent = $rootScope.$on('currentScope.change', function () {
            if (isInCurrentScope(rootScope, scope)) {
              onEvent();
              deferred.resolve();
              scope = null;
              onEvent = null;
              deferred = null;
            }
          });
        }
        return deferred.promise.then(callback || window.angular.noop);
      }
    };
  });
  return app;
};

require('angular');

/**
 * 获取当前scope绑定的作用域
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/services/currentScope.js
// module id = 147
// module chunks = 0